
import { Component, Prop, Vue } from "vue-property-decorator";

import PEOPLE_IMAGE from "@/modules/Services/Components/Table/assets/People.png";

const MESSAGES = {
  title: "All your immigration needs in one place!",
  description:
    `We know that sponsoring international talent is time-consuming and,\n` +
    `frankly speaking, quite stressful, but with Nation.better digital platform and\n` +
    `on-call immigration support, you get a smooth, confusion-free, and\n` +
    `streamlined experience.`,
  helloDescription:
    "Here you can start Nation.better services and get step-by-step guidance\n" +
    "and support from immigration experts.",
};

@Component
export default class ServicesTablePlaceholder extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showHelloMessage!: boolean;

  PEOPLE_IMAGE = PEOPLE_IMAGE;

  get classes() {
    return {
      hello_description: this.showHelloMessage,
    };
  }

  get title() {
    return MESSAGES.title;
  }

  get description() {
    return this.showHelloMessage ? MESSAGES.helloDescription : MESSAGES.description;
  }
}
